<template>
    <Teleport
        to="body"
        v-if="showSelf"
    >
        <div class="modals-container">
            <div class="modal-wrapper" style="z-index: 1">
                <div class="modal"
                    :style="{
                        'height': '90vh',
                        'max-height': '880px',
                        'max-width': sMaxWidth,
                    }"
                >
                    <!-- ↓高度 -->
                    <div class="modal__container"
                        :class="{'has-height': true}" 
                    >
                        <button title="Close modal" class="modal__btn-close"
                            @click="closeSelf"
                        >
                            <IconSvgUse use="icon-cross-small" />
                        </button>
                        <!-- ↑ 关闭按钮 -->
                        <!-- ↓ 窗口内容 -->
                        <div class="default-tab">
                            <article class="tab-inner "
                                :class="{'onboarding-roulette': joinStore.gameOfRoute === 'rouletteGame'}" 
                                open-tab="function () { [native code] }" 
                            >
                                <section class="body">
                                    <div class="body__inner">
                                        <!-- ↓ rouletteGame  -->
                                        <contentRoulette v-if="joinStore.gameOfRoute === 'rouletteGame'" />
                                        <!-- ↓ corgipharaohGame  -->
                                        <contentPharaoh v-else-if="joinStore.gameOfRoute === 'corgipharaohGame'" />
                                    </div>
                                </section>
                                <!--
                                    ↑ 特定游戏的内容
                                    ↓ 通用按钮
                                -->
                                <section class="footer onboarding-roulette__actions abc123">
                                    <button class="button-flat button-flat_md button-flat_grey2 button-flat_center button-flat_fullwidth"
                                        @click="goHomePage" 
                                    >
                                        <span class="button-flat__inner">
                                            <span class="button-flat__text">
                                                <!-- Exit to Lobby -->
                                                {{$t('ExitToLobby')}}
                                            </span>
                                        </span>
                                    </button>
                                    <!--  -->
                                    <ButtonThe3DButton color="red" size="lg" @click="closeSelf" >
                                        {{$t('StartPlaying')}}
                                    </ButtonThe3DButton>
                                </section>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>


<script lang="ts">
import {mapStores} from 'pinia';
import {useJoinStateStore} from '~/stores/cansino/joinState';
import useGlobalStore from '@/stores/global';
import contentRoulette from './component/contentRoulette.vue';
import contentPharaoh from './component/contentPharaoh.vue';


export default defineComponent({
    name: 'GameIntroduction',
    components: {
        contentRoulette,
        contentPharaoh,
    },
    data(){
        return {
            showSelf: true,
        };
    },
    computed: {
        ...mapStores(useJoinStateStore, useGlobalStore),
        // ↓ 最大宽度（游戏不同，窗口宽度不同）
        sMaxWidth(){
            const {gameOfRoute} = this.joinStore;
            const {innerWidth} = this.globalStore;
            // 'rouletteGame' 'corgipharaohGame'
            if (gameOfRoute === 'corgipharaohGame'){
                if (innerWidth < 1100) return '400px'; // 原版是 360px 
                // if (innerWidth < 1100) return '360px';
            }
            return '750px';
        },
    },
    watch:{
        showSelf:{
            immediate: true,
            handler(bNewValue){
                if (!import.meta.client) return;
                console.log('窗口新值：', bNewValue); 
                const sValue = bNewValue ? 'hidden' : 'auto';
                document.body.style.overflow = sValue;
            },
        },
    },
    mounted(){
        // console.log("this.joinStore ==");
    },
    methods:{
        closeSelf(){
            this.showSelf = false; 
        },
        async goHomePage(){
            this.showSelf = false; 
            await this.$nextTick(); 
            useNavigator('/');
        },
    },
});

</script>

<style scoped lang="scss" src="./style/GameIntroduction.scss"></style>
<style scoped lang="scss" src="./style/gray-btn.scss"></style>
<style scoped lang="scss" src="./style/GameIntroduction-3.scss"></style>

<style scoped lang="scss">
.onboarding-roulette {
    position: relative
}

.onboarding-roulette .body__inner {
    background: #070827
}

.onboarding-roulette .body__inner:before {
    display: none
}

.onboarding-roulette .body__inner:after {
    background: linear-gradient(176deg,#0a1897,#0a189700 85%);
    content: "";
    height: 362px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0
}

</style>


